import React from 'react';
import { Box, costFormater, Hint, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  fill: ${({ theme }) => theme.colors.iconDisabled};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    opacity: 1;
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
`;

interface Props {
  label: string;
  value?: number;
  description?: string;
  isBold?: boolean;
  testId?: string;
  hintText?: string;
}

const BankingBalanceDetailRow: React.FC<Props> = ({ label, value, description, isBold, testId, hintText }) => (
  <Box
    data-testid={testId}
    height={description ? '40px' : '24px'}
    direction="row"
    align="center"
    justify="between"
  >
    <Box>
      <Inscription lineHeight="20px">
        {label}
      </Inscription>

      {description ? (
        <Inscription
          lineHeight="18px"
          weight={500}
          size="12px"
          color="textSecondary"
          margin={{ top: 'spacing2' }}
        >
          {description}
        </Inscription>
      ) : null}
    </Box>

    <Box direction="row" gap="spacing2" align="center">
      <Inscription lineHeight="20px" weight={isBold ? 'bold' : undefined}>
        {costFormater(value, true)}
      </Inscription>

      {hintText ? (
        <Hint
          data-testid={testId}
          hintElevation="default"
          contentStyles={{
            marginLeft: '0',
            width: '320px',
          }}
          hintElement={
            <StyledInfoIcon
              data-testid={testId ? `${testId}_icon` : undefined}
              size="16px"
              color="iconOnColor"
            />
          }
        >
          <Box>
            <Inscription size="small">
              {hintText}
            </Inscription>
          </Box>
        </Hint>
      ) : null}
    </Box>
  </Box>
);

export default BankingBalanceDetailRow;
